import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import UserPostCentreLayout from "./Layout/UserAccountGridCenter";
import { MediaDisplayContext } from "../../../context/MediaDisplayModeContext";
import OnboardingPopups from "./Utils/onboardingPopups";
import "./UserAccountGridLayout.css";
import UserAccountGridLeft from "./Layout/UserAccountGridLeft";
import UserAccountGridRight from "./Layout/UserAccountGridRight";
// import Navbar from "@beta/components/common/Navbar/Navbar";

const UserFeed = () => {
  const { theme } = useContext(ThemeContext);
  const { displayMode } = useContext(MediaDisplayContext);
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const { profileid, action } = useParams();
  const [activetab, setActivetab] = useState("feed");
  const { userId } = useParams();

  const DEFAULT_FREE_FEATURES = ["LS", "FRIEND", "GROUP", "ARCHIVE"];

  console.log("userId: ", userId);

  useEffect(() => {
    import(`../Styles/themes/${theme}/themes.css`)
      .then(() => {
        console.log(`Loaded ${theme} styles for User Account`);
      })
      .catch(() => {
        console.error(`Theme CSS not found for ${theme}`);
      });
  }, [theme]);

  useEffect(() => {
    if (action && action.trim() !== "") {
      setActivetab(action);
    } else {
      setActivetab("feed");
    }
  }, [action]);

  useEffect(() => {
    const loggedIn = JSON.parse(localStorage.getItem("userLoggedin"));
    const users = JSON.parse(localStorage.getItem("users")) || [];

    if (loggedIn && users.length > 0) {
      const matchedUser = users.find(
        (u) =>
          (u.userId === loggedIn.login ||
            u.email === loggedIn.login ||
            u.mobile === loggedIn.login) &&
          u.password === loggedIn.password
      );

      if (matchedUser) {
        setIsFirstLogin(matchedUser.firstTimeLogin === true);
      } else {
        setIsFirstLogin(false);
      }
    } else {
      setIsFirstLogin(false);
    }
  }, []);

  useEffect(() => {
    try {
      const existingFeatures = localStorage.getItem("features");

      if (!existingFeatures) {
        localStorage.setItem("features", JSON.stringify(DEFAULT_FREE_FEATURES));
        console.log("✅ Initialized default free features:", DEFAULT_FREE_FEATURES);
      } else {
        console.log("📋 Features already initialized:", JSON.parse(existingFeatures));
      }
    } catch (err) {
      console.error("❌ Error initializing features:", err);
    }
  }, []);

  return (
    <div className="uaf-page-wrapper">
      <div className={`uaf-page media-${displayMode}`}>

        {/* Navbar is outside the scrollable grid */}
        {/* Your navbar component goes here */}
        {/* <Navbar /> */}

        {/* ONLY THIS AREA SCROLLS */}
        <div className={`uaf-page-grid media-${displayMode}`}>

          {/* Left sidebar */}
          <aside className="uaf-left-sidebar">
            <UserAccountGridLeft />
          </aside>

          {/* Middle feed */}
          <main className="uaf-middle-container">
            <UserPostCentreLayout
              pagetype="feed"
              mediaDisplayMode={displayMode}
              userId={userId}
              profileId={profileid}
              activeTab={activetab}
              setActiveTab={setActivetab}
            />
          </main>

          {/* Right sidebar */}
          <aside className="uaf-right-sidebar">
            <UserAccountGridRight />
          </aside>

        </div>

        {/* Footer stays visible */}
        <footer className="uaf-footer">
          <p className="uaf-footer-text">
            Kleido AI, an Intelligent social platform.
            Copyright © InitiumNet Technology Pvt Ltd.
          </p>
        </footer>

      </div>

      {isFirstLogin && <OnboardingPopups />}
    </div>
  );
};

export default UserFeed;
